<div class="standard-max-width">
  <div class="flex align-items-center justify-content-between mb-6 mt-2">
    <div class="flex align-items-center">
      <i class="pi pi-building text-2xl mr-2"></i>
      <span class="text-2xl font-semibold">{{ 'MANAGE_ORG' | translate }}</span>
    </div>
    <div class="flex gap-2"> <!-- Wrap buttons in a div for layout -->
      <ng-container *ngIf="mode === 'read'">
        <button pButton type="button" icon="pi pi-pencil" [label]="'EDIT' | translate" class="p-button-text"
          (click)="enableEditMode()"></button>
      </ng-container>
      <ng-container *ngIf="mode === 'update'">
        <button pButton type="button" icon="pi pi-times" [label]="'CANCEL' | translate" class="p-button-text"
          (click)="onCancel()"></button>
      </ng-container>
    </div>
  </div>
  <app-crud-org [mode]="mode" [styleForOnboarding]="false" [orgId]="orgId!"
    (UpdateSuccess)="onUpdateSuccess()"></app-crud-org>
  <hr class="my-4">
  <div class="flex align-items-center justify-content-between mb-3">
    <span class="text-xl font-semibold flex align-items-center">
      <i class="pi pi-envelope text-xl mr-2"></i>
      {{ 'MANAGE_ORG_INVITES' | translate }}
    </span>
    <!-- Buttons for invite section modes can be added here if needed -->
  </div>
  <app-crud-org-invites [orgId]="orgId!"></app-crud-org-invites>
  <hr class="my-4">
  <div class="flex align-items-center justify-content-between mb-3">
    <span class="text-xl font-semibold flex align-items-center">
      <i class="pi pi-users text-xl mr-2"></i>
      {{ 'MANAGE_ORG_USERS' | translate }}
    </span>
    <div class="flex gap-2"> <!-- Wrap buttons in a div for layout -->
      <ng-container *ngIf="permissionsMode === 'read'">
        <button pButton type="button" icon="pi pi-pencil" [label]="'EDIT' | translate" class="p-button-text"
          (click)="enablePermissionsEditMode()"></button>
      </ng-container>
      <ng-container *ngIf="permissionsMode === 'update'">
        <button pButton type="button" icon="pi pi-plus" [label]="'ADD_USER' | translate" class="p-button-outlined"
          (click)="openAddUserDialog()"></button>
        <button pButton type="button" icon="pi pi-times" [label]="'CANCEL' | translate" class="p-button-text"
          (click)="cancelPermissionsEditMode()"></button>
      </ng-container>
    </div>
  </div>
  <app-crud-org-permissions [orgId]="orgId!" [mode]="permissionsMode"></app-crud-org-permissions>



  <!-- Add User Dialog -->
  <p-dialog header="{{ 'ADD_NEW_USER_TO_ORG' | translate }}" [(visible)]="showAddUserDialog" [modal]="true"
    [style]="{ width: '50vw' }" [appendTo]="'body'" [baseZIndex]="10000" [draggable]="false" [resizable]="false"
    (onHide)="closeAddUserDialog()">
    <app-crud-user mode="create" roleContext="orgAdmin" [orgId]="orgId!" (cancelPressed)="closeAddUserDialog()"
      (updateSuccess)="closeAddUserDialog()" (createSuccess)="onCreateSuccess()"></app-crud-user>
    <!-- Note: updateSuccess might not be the correct event for creation, adjust if needed -->
  </p-dialog>